/* ═══════════════════════════════════════════════════════════════════════════
 * TRADUCTION — LE POINT DE PASSAGE, POSÉ AVANT D'EN AVOIR BESOIN
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ CE N'EST PAS L'INTERNATIONALISATION. Une seule langue existe : le français.
 *    Ce fichier ne traduit rien aujourd'hui — il rend exactement ce qu'on lui
 *    donne. Son seul rôle est d'être **LE PASSAGE OBLIGÉ** des libellés.
 *
 * ⚠️ POURQUOI MAINTENANT, ALORS QUE ÇA NE SERT À RIEN AUJOURD'HUI
 *    « C'est gratuit aujourd'hui, c'est un chantier de plusieurs semaines dans
 *    un an. » (Dom, 04/09/2026) — Reprendre après coup des milliers de chaînes
 *    dispersées dans des dizaines d'écrans, c'est le genre de chantier qu'on
 *    reporte indéfiniment parce qu'il ne produit rien de visible. Poser le
 *    passage maintenant coûte une ligne par libellé neuf.
 *
 * ⚠️ CE QU'IL NE FAUT PAS FAIRE : convertir l'existant. Une reprise massive
 *    toucherait chaque écran du produit pour aucun gain immédiat, et chaque
 *    fichier touché est un fichier qu'il faut redéployer et re-recetter.
 *    ➡️ RÈGLE : **tout NOUVEAU libellé passe par `t()`. L'existant migre quand
 *       on touche à l'écran pour une autre raison** — jamais en lot dédié.
 *
 * ⚠️ LA LANGUE SERA UN RÉGLAGE DU **TENANT**, PAS DU PAYS. Le Cameroun est
 *    bilingue : VIGIE est à Douala (francophone), mais les régions du
 *    Nord-Ouest et du Sud-Ouest sont anglophones. Déduire la langue de
 *    `pays_code` produirait du français pour un client de Bamenda.
 *    `public.tenants.langue` existe déjà — c'est elle qui devra être lue.
 *    Voir la file dans CLAUDE.md, chantier « i18n ».
 */

/** La langue active. Une seule aujourd'hui ; lue du tenant le jour venu. */
const LANGUE_PAR_DEFAUT = 'fr';

/**
 * Les traductions, quand il y en aura. Vide n'est pas un oubli : c'est l'état
 * réel. Une entrée absente rend la clé telle quelle — donc le français écrit
 * dans le code reste affiché tant que rien ne le remplace.
 */
const TRADUCTIONS = {
  fr: {},
};

/**
 * Le libellé à afficher.
 *
 * @param {string} texte  Le libellé EN FRANÇAIS, écrit en clair. Ce n'est pas
 *   une clé technique (`btn.save`) mais la phrase elle-même : un code lisible
 *   vaut mieux qu'un dictionnaire à consulter, et une chaîne absente du
 *   dictionnaire reste correcte à l'écran.
 * @param {object} [valeurs]  Substitutions `{nom}` → valeur.
 * @returns {string}
 *
 * @example  t('Générer le PDF')
 * @example  t('{n} personnes sans contrat', { n: 3 })
 */
export function t(texte, valeurs) {
  const table = TRADUCTIONS[LANGUE_PAR_DEFAUT] || {};
  let sortie = table[texte] !== undefined ? table[texte] : texte;
  if (valeurs) {
    for (const [cle, val] of Object.entries(valeurs)) {
      sortie = sortie.split(`{${cle}}`).join(String(val));
    }
  }
  return sortie;
}

/** La langue active — pour le jour où elle viendra du tenant. */
export function langueActive() {
  return LANGUE_PAR_DEFAUT;
}

export default t;
